import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_SELECT_SUBJECT_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_SELECT_SUBJECT_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface SubjectResultModelsObject {
  status: string;
  subjectGroup: string;
  subjectCode: string;
  subject: string;
  gradeNumerical: string;
  gradeAlphabetical: string;
  hurdleGrade: string;
  examLevel: string;
  languageMedium: string;
  examiningAuthority: string;
  selected: boolean;
}

export interface CoordinatorAppealSelectSubjectResponse {
  candidateCitizenship: string;
  subjectResultModels: SubjectResultModelsObject[];
  examLevel: string;
  examYear: number;
  examCode: string;
  examSchool: string;
  candidateId: string;
  candidateIndexNum: string;
  candidateName: string;
  examSeries: string;
  blockStatus: boolean;
  examSeriesCode: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: CoordinatorAppealSelectSubjectResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetCoordinatorAppealSelectSubject = ({ onSuccess, onError, uuid }: Input) => {
  const getCoordinatorAppealSelectSubject = async () => {
    const res = await axiosClient.get<CoordinatorAppealSelectSubjectResponse>(
      GET_COORDINATOR_APPEAL_SELECT_SUBJECT_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_COORDINATOR_APPEAL_SELECT_SUBJECT_QUERY_KEY,
    getCoordinatorAppealSelectSubject,
    {
      onSuccess,
      onError,
    }
  );
};
